import { isPublicPage } from './utils';

/**
 * App Settings
 */

const settings = {
  night_mode: isPublicPage() ? false : JSON.parse(window.localStorage.getItem('darkMode')) || false,
  spotlight_mode: false,
  show_section_lines: true,
  sidebar_dark: false,
  sidebar_static: false,
  sidebar_small: false,
  sidebar_effect: 'shrink',
  nav: true,
  nav_dark: false,
  nav_logo_path: require('../assets/images/logo.svg'),
  nav_logo_white_path: require('../assets/images/logo-white.svg'),
  logo_mobile: require('../assets/images/mayarlogo-small.png'),
  nav_logo_width: '45px',
  logo_mobile_width: '85px',
  logo_mobile_height: '30px',
  nav_logo_url: '/',
  nav_align: 'left',
  nav_expand: 'lg',
  nav_sticky: true,
  nav_autohide: true,
  nav_container_fluid: true,
  home_url: '/',
  navigation: {
    '#actions': {
      name: 'Actions',
      icon: 'layers',
      sub: {
        '#create-post': {
          name: 'Create Post',
          icon: 'plus-circle'
        },
        '#create-page': {
          name: 'Create Page',
          icon: 'plus-circle'
        },
        '#manage-users': {
          name: 'Manage Users',
          icon: 'users'
        },
        '#manage-sites': {
          name: 'Manage Sites',
          icon: 'sidebar',
          sub: {
            '#my-site-1': {
              name: 'My Site 1'
            },
            '#my-site-2': {
              name: 'My Site 2'
            },
            '#my-site-3': {
              name: 'My Site 3'
            }
          }
        }
      }
    }
  },
  navigation_sidebar: {
    '/': {
      name: 'Beranda',
      icon: 'home'
    },

    // Apps
    '/customers': {
      name: 'Pelanggan',
      icon: 'users'
    },
    '/payments': {
      name: 'Transaksi',
      icon: 'layers'
    },
    '/recurring-payments': {
      name: 'Berlangganan',
      icon: 'repeat'
    },
    '/orders': {
      name: 'Order',
      icon: 'shopping-bag'
    },
    '/payment-requests': {
      name: 'Permintaan Pembayaran',
      icon: 'send',
      sub: {
        '/single-payment-requests': {
          name: 'Penagihan'
        },
        '/batch-payment-requests': {
          name: 'Penagihan Massal'
        },
        '/invoices': {
          name: 'Invoice'
        },
        '/installments': {
          name: 'Cicilan'
        }
      }
    },
    '/all-products': {
      label: 'Produk',
      name: 'Semua Produk',
      icon: 'layers'
    },
    '/payment-link': {
      name: 'Link Pembayaran',
      icon: 'link'
    },
    '/physical-products': {
      name: 'Produk Fisik',
      icon: 'tag'
    },
    '/digital-products': {
      name: 'Produk Digital',
      icon: 'download-cloud'
    },
    '/online-courses': {
      name: 'Kelas Online (OD)',
      icon: 'book-open'
    },
    '/cohort-courses': {
      name: 'Kelas Cohort / Bootcamp',
      icon: 'grid'
    },
    '/webinars': {
      name: 'Webinar',
      icon: 'video'
    },
    '/events': {
      name: 'Event & Acara',
      icon: 'aperture'
    },
    '/coachings': {
      name: 'Coaching & Mentoring',
      icon: 'watch'
    },
    '/fundraisings': {
      name: 'Penggalangan Dana',
      icon: 'heart'
    },
    '/ebooks': {
      name: 'E-Book',
      icon: 'eye'
    },
    '/podcasts': {
      name: 'Podcast',
      icon: 'mic'
    },
    '/audiobooks': {
      name: 'Audio Book',
      icon: 'headphones'
    },
    '/writings': {
      name: 'Tulisan',
      icon: 'pen-tool'
    },
    '/comics': {
      name: 'Web Komik',
      icon: 'book'
    },
    '/memberships': {
      name: 'Membership & SaaS',
      icon: 'award'
    },
    '/license-codes': {
      name: 'Lisensi Software',
      icon: 'key'
    },
    '/credit-usage-products': {
      name: 'Produk Berbasis Credit',
      icon: 'dollar-sign'
    },
    '/payroll-overview': {
      name: 'Payroll',
      icon: 'feather',
      sub: {
        '/employees': {
          name: 'Data Karyawan'
        },
        '/payroll': {
          name: 'Pembayaran Gaji'
        }
      }
    },
    '/financial-overview': {
      name: 'Bill Payment',
      icon: 'check-circle',
      sub: {
        '/bill-payments': {
          name: 'Pembayaran Invoice'
        },
        '/mcredit': {
          name: 'Mayar Credit'
        },
        '/mass-bill-payments': {
          name: 'Pembayaran Massal'
        }
      }
    },
    '/money-transfers-overview': {
      name: 'Kirim Uang',
      icon: 'arrow-up-right',
      sub: {
        '/money-transfers': {
          name: 'Kirim Uang'
        },
        '/mass-money-transfers': {
          name: 'Kirim Uang Massal'
        }
      }
    },
    '/capital': {
      name: 'Capital / Pendanaan',
      icon: 'briefcase'
    },
    '/storefront-overview': {
      name: 'Halaman Utama',
      label: 'Marketing',
      icon: 'layout',
      sub: {
        '/storefront': {
          name: 'Halaman Utama'
        },
        '/tags': {
          name: 'Tags'
        }
      }
    },
    '/broadcasts-overview': {
      name: 'Broadcast',
      icon: 'rss',
      sub: {
        '/broadcasts': {
          name: 'Broadcast'
        },
        '/customer-segment': {
          name: 'Segmen Pelanggan'
        }
      }
    },
    '/autoresponders': {
      name: 'Auto Responder',
      icon: 'target'
    },
    '/landing-page-overview': {
      name: 'Landing Page',
      icon: 'airplay',
      sub: {
        '/simple-landing-pages': {
          name: 'Simple Landing Page Builder'
        },
        '/ai-landing-pages': {
          name: 'AI Landing Page Builder'
        },
        '/landing-pages': {
          name: 'Advance Landing Page'
        }
      }
    },
    '/affiliates': {
      name: 'Affiliate',
      icon: 'award'
    },
    '/as-affiliate': {
      name: 'Produk Affiliate',
      icon: 'Award'
    },
    '/diskon': {
      name: 'Diskon dan Kupon',
      icon: 'percent'
    },
    '/bundling': {
      name: 'Bundling',
      icon: 'box'
    },
    '/crosssells': {
      name: 'Cross-sell',
      icon: 'arrow-up-circle'
    },
    '/balance': {
      label: 'Akun Saya',
      name: 'Mayar Wallet (Saldo)',
      icon: 'dollar-sign'
    },
    '/mcredit': {
      name: 'Mayar Credit',
      icon: 'circle'
    },
    '/analytics': {
      name: 'Analytics',
      icon: 'bar-chart'
    },
    // Pls don't delete this, might use it again in the future cause this version is the more detailed analytics
    // '/analytics': {
    //   name: 'Analytics',
    //   icon: 'bar-chart',
    //   sub: {
    //     '/analytics-overview': {
    //       name: 'Overview'
    //     },
    //     '/detail-analytics': {
    //       name: 'Detail Analytics'
    //     }
    //   }
    // },
    '/my-qris': {
      name: 'Qris Statis',
      icon: 'maximize'
    },
    '/verification': {
      name: 'Verifikasi Akun',
      icon: 'user-check'
    },
    '/settings': {
      name: 'Pengaturan',
      icon: 'settings'
    },
    '/developer-tools': {
      name: 'Integrasi',
      icon: 'code',
      sub: {
        '/api-keys': {
          name: 'API Keys & Token'
        },
        '/webhook': {
          name: 'Webhook'
        },
        '/whatsapp-unofficial': {
          name: 'Whatsapp Unofficial'
        },
        '/whatsapp-official': {
          name: 'Whatsapp Official'
        },
        '/telegram-notification': {
          name: 'Telegram Notification'
        },
        '/mcp-server': {
          name: 'MCP Server'
        },
        '/ai-agent': {
          name: 'AI Agent'
        },
        '/headless-checkout': {
          name: 'Headless Custom Checkout'
        }
      }
    },
    '/billing': {
      name: 'Upgrade ke Mayar Pro',
      icon: 'zap'
    },
    '/refer-a-friend': {
      name: 'Refer a Friend',
      icon: 'gift'
    }
    // '/suggestions': {
    //   name: 'Kritik dan Saran',
    //   icon: 'message-square'
    // }

    //'/admin': {
    //  label: 'Navigasi Sementara',
    //  name: 'Ke Halaman Admin',
    //  icon: 'lock',
    //},
  },
  navigation_sidebar_admin: {
    '/admin': {
      name: 'Dashboard',
      icon: 'codesandbox'
    },

    // Apps
    '/admin/withdrawals': {
      name: 'Penarikan Dana',
      icon: 'dollar-sign'
    },
    '/admin/payments': {
      name: 'Pembayaran',
      icon: 'layers'
    },
    '/admin/payment-requests': {
      name: 'Tagihan',
      icon: 'send'
    },
    '/admin/payment-links': {
      name: 'Link Pembayaran',
      icon: 'link'
    },
    '/admin/payment-plans': {
      name: 'Paket Berlangganan',
      icon: 'calendar'
    },
    '/admin/recurring-payments': {
      name: 'Berlangganan',
      icon: 'repeat'
    },
    '/admin/users': {
      label: 'Master Data',
      name: 'Pengguna',
      icon: 'user-check'
    },
    '/admin/customers': {
      name: 'Pembeli (Pelanggan)',
      icon: 'users'
    },
    '/admin/settings': {
      label: 'Platform / Aplikasi',
      name: 'Pengaturan',
      icon: 'settings'
    },
    '/': {
      label: 'Navigasi Sementara',
      name: 'Ke Halaman Pengguna',
      icon: 'lock'
    }
  },
  breadcrumbs_presets: {
    apps: {
      '/mailbox': 'Mailbox',
      '/messenger': 'Messenger',
      '/calendar': 'Calendar',
      '/project-management': 'Project Management',
      '/file-manager': 'File Manager',
      '/profile': 'Profile'
    },
    content: {
      '/grid': 'Grid',
      '/colors': 'Colors',
      '/typography': 'Typography',
      '/component-table': 'Tables'
    },
    components_base: {
      '/component-alert': 'Alert',
      '/component-badge': 'Badge',
      '/component-breadcrumbs': 'Breadcrumbs',
      '/component-button': 'Button',
      '/component-card': 'Card',
      '/component-carousel': 'Carousel',
      '/component-collapse': 'Collapse',
      '/component-dropdown': 'Dropdown',
      '/component-list-group': 'List Group',
      '/component-media-object': 'Media Object',
      '/component-modal': 'Modal',
      '/component-nav': 'Nav',
      '/component-pagination': 'Pagination',
      '/component-popover': 'Popover',
      '/component-progress': 'Progress',
      '/component-spinner': 'Spinner',
      '/component-tabs': 'Tabs'
    },
    components_advanced: {
      '/component-icons-feather': 'Icons: Feather',
      '/component-icons-fontawesome': 'Icons: Font Awesome',
      '/component-charts-chartjs': 'Charts: Chart.js',
      '/component-charts-chartist': 'Charts: Chartist',
      '/component-charts-peity': 'Charts: Peity',
      '/component-charts-echarts': 'Charts: eCharts',
      '/component-charts-flot': 'Charts: Flot',
      '/component-timeline': 'Timeline',
      '/component-tree-view': 'Tree View',
      '/component-toast': 'Toast',
      '/component-sweet-alert': 'Sweet Alert',
      '/component-maps': 'Maps',
      '/component-data-tables': 'Data Tables'
    },
    forms_advanced: {
      '/forms-datetime': 'DateTime Picker',
      '/forms-validation': 'Validation',
      '/forms-touch-spin': 'Touch Spin',
      '/forms-range-slider': 'Range Slider',
      '/forms-input-masks': 'Input Masks',
      '/forms-dropzone': 'Dropzone',
      '/forms-colorpicker': 'Color Picker',
      '/forms-select': 'Select',
      '/forms-markdown': 'Markdown editor',
      '/forms-wysiwyg': 'WYSIWYG editor'
    }
  },
  img_country: {
    usa: require('../assets/images/flags/united-states-of-america.svg'),
    china: require('../assets/images/flags/china.svg'),
    germany: require('../assets/images/flags/germany.svg'),
    japan: require('../assets/images/flags/japan.svg'),
    spain: require('../assets/images/flags/spain.svg'),
    france: require('../assets/images/flags/france.svg'),
    canada: require('../assets/images/flags/canada.svg'),
    netherlands: require('../assets/images/flags/netherlands.svg'),
    italy: require('../assets/images/flags/italy.svg'),
    russia: require('../assets/images/flags/russia.svg'),
    czech_republic: require('../assets/images/flags/czech-republic.svg')
  },
  img_file: {
    empty: require('../assets/images/icon-empty.svg'),
    zip: require('../assets/images/icon-zip.svg'),
    rar: require('../assets/images/icon-rar.svg'),
    html: require('../assets/images/icon-html.svg'),
    php: require('../assets/images/icon-php.svg'),
    css: require('../assets/images/icon-css.svg'),
    js: require('../assets/images/icon-js.svg'),
    doc: require('../assets/images/icon-doc.svg'),
    txt: require('../assets/images/icon-txt.svg'),
    pdf: require('../assets/images/icon-pdf.svg'),
    xls: require('../assets/images/icon-xls.svg'),
    png: require('../assets/images/icon-png.svg'),
    jpg: require('../assets/images/icon-jpg.svg')
  },
  users: [
    {
      img: require('../assets/images/avatar-1.png'),
      img_profile: require('../assets/images/avatar-1-profile.png'),
      name: 'Jack Boyd'
    },
    {
      img: require('../assets/images/avatar-2.png'),
      name: 'Helen Holt'
    },
    {
      img: require('../assets/images/avatar-3.png'),
      name: 'Avice Harris'
    },
    {
      img: require('../assets/images/avatar-4.png'),
      name: 'Anna Rice'
    },
    {
      img: require('../assets/images/avatar-5.png'),
      name: 'Amber Smith'
    },
    {
      img: require('../assets/images/avatar-6.png'),
      name: 'Mary Rose'
    }
  ],
  letters: [
    {
      img: require('../assets/images/letter-1.png'),
      img_min: require('../assets/images/letter-1-min.png')
    },
    {
      img: require('../assets/images/letter-2.png'),
      img_min: require('../assets/images/letter-2-min.png')
    },
    {
      img: require('../assets/images/letter-3.png'),
      img_min: require('../assets/images/letter-3-min.png')
    },
    {
      img: require('../assets/images/letter-4.png'),
      img_min: require('../assets/images/letter-4-min.png')
    }
  ]
};

// ==================== NAVIGATION FILTER CONFIG ====================
const NAV_CONFIG = {
  MENU_MAP: {
    payments: '/payments',
    customers: '/customers',
    'recurring-payments': '/recurring-payments',
    orders: '/orders',
    'payment-requests': '/payment-requests',
    'all-products': '/all-products',
    'payment-link': '/payment-link',
    'physical-products': '/physical-products',
    'digital-products': '/digital-products',
    'online-courses': '/online-courses',
    'cohort-courses': '/cohort-courses',
    webinars: '/webinars',
    events: '/events',
    coachings: '/coachings',
    fundraisings: '/fundraisings',
    'payment-plans': '/payment-plans',
    ebooks: '/ebooks',
    podcasts: '/podcasts',
    audiobooks: '/audiobooks',
    writings: '/writings',
    comics: '/comics',
    'support-page': '/support-page',
    memberships: '/memberships',
    'license-codes': '/license-codes',
    'credit-usage-products': '/credit-usage-products',
    'debit-card': '/debit-card',
    'payroll-overview': '/payroll-overview',
    'financial-overview': '/financial-overview',
    'money-transfers-overview': '/money-transfers-overview',
    capital: '/capital',
    'storefront-overview': '/storefront-overview',
    'broadcasts-overview': '/broadcasts-overview',
    autoresponders: '/autoresponders',
    homepage: '/homepage',
    'landing-page-overview': '/landing-page-overview',
    affiliates: '/affiliates',
    'as-affiliate': '/as-affiliate',
    diskon: '/diskon',
    bundling: '/bundling',
    crosssells: '/crosssells',
    balance: '/balance',
    mcredit: '/mcredit',
    analytics: '/analytics',
    'my-qris': '/my-qris',
    'developer-tools': '/developer-tools',
    billing: '/billing',
    'refer-a-friend': '/refer-a-friend',
    verification: '/verification'
  },

  GROUPS: {
    general: ['/', 'payments', 'customers', 'recurring-payments', 'orders', 'payment-requests'],
    products: [
      'all-products',
      'payment-link',
      'physical-products',
      'digital-products',
      'online-courses',
      'cohort-courses',
      'webinars',
      'events',
      'coachings',
      'fundraisings',
      'payment-plans',
      'ebooks',
      'podcasts',
      'audiobooks',
      'writings',
      'comics',
      'support-page',
      'memberships',
      'license-codes',
      'credit-usage-products'
    ],
    financial: ['debit-card', 'payroll-overview', 'financial-overview', 'money-transfers-overview', 'capital'],
    marketing: [
      'storefront-overview',
      'broadcasts-overview',
      'autoresponders',
      'homepage',
      'landing-page-overview',
      'affiliates',
      'as-affiliate',
      'diskon',
      'bundling',
      'crosssells'
    ],
    account: [
      'balance-overview',
      'balance',
      'mcredit',
      'analytics',
      'my-qris',
      'developer-tools',
      'billing',
      'refer-a-friend',
      'verification'
    ]
  },

  LABELS: {
    general: 'General',
    products: 'Produk',
    financial: 'Finansial',
    marketing: 'Marketing',
    account: 'Akun Saya'
  },

  SUBMENU_RULES: {
    'payment-requests': {
      '/single-payment-requests': 'payment-requests-billing',
      '/batch-payment-requests': 'payment-requests-mass-billing',
      '/invoices': 'invoices',
      '/installments': 'installments'
    },
    'payroll-overview': {
      '/employees': 'payroll-employees',
      '/payroll': 'payroll-payments'
    },
    'financial-overview': {
      '/bill-payments': 'financial-bill-payments',
      '/mass-bill-payments': 'financial-mass-bill-payments'
    },
    'money-transfers-overview': {
      '/money-transfers': 'money-transfers',
      '/mass-money-transfers': 'money-transfers-mass'
    },
    'storefront-overview': {
      '/storefront': 'storefront-main',
      '/tags': 'storefront-tags'
    },
    'broadcasts-overview': {
      '/broadcasts': 'broadcasts-main',
      '/customer-segment': 'broadcasts-segment'
    },
    'landing-page-overview': {
      '/simple-landing-pages': 'landing-page-simple',
      '/landing-pages': 'landing-page-advance',
      '/ai-landing-pages': 'landing-page-ai'
    },
    analytics: {
      '/analytics-overview': 'analytics-overview',
      '/detail-analytics': 'analytics-detail'
    },
    'developer-tools': {
      '/api-keys': 'developer-api-keys',
      '/webhook': 'developer-webhook',
      '/whatsapp-unofficial': 'developer-whatsapp-unofficial',
      '/whatsapp-official': 'developer-whatsapp-official',
      '/telegram-notification': 'developer-telegram',
      '/mcp-server': 'developer-mcp-server',
      '/ai-agent': 'developer-ai-agent',
      '/headless-checkout': 'developer-headless-checkout'
    }
  }
};

// ==================== NAVIGATION FILTER LOGIC ====================
const NavigationFilter = (() => {
  let cache = { config: null, result: null };

  const getMenuConfig = userData => {
    try {
      if (userData?.menuConfig) {
        const parsed = typeof userData.menuConfig === 'string' ? JSON.parse(userData.menuConfig) : userData.menuConfig;
        return parsed;
      }
      if (typeof window !== 'undefined' && window.__REDUX_STORE__) {
        const state = window.__REDUX_STORE__.getState();
        if (state.currentUser?.menuConfig) {
          const parsed =
            typeof state.currentUser.menuConfig === 'string'
              ? JSON.parse(state.currentUser.menuConfig)
              : state.currentUser.menuConfig;
          return parsed;
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error parsing menuConfig:', error);
    }
    return null;
  };

  const shouldInclude = (menuId, config) => {
    // Always show home
    if (menuId === '/' && settings.navigation_sidebar['/']) return true;

    // If no config provided, show all menus (default behavior)
    if (!config) return true;

    // Support both old array format and new object format
    if (Array.isArray(config)) {
      return config.includes(menuId);
    }

    // New object format: default true unless explicitly set to false
    return config[menuId] !== false;
  };

  const filterSubmenus = (menuId, item, config) => {
    if (!item.sub) return item;

    const rules = NAV_CONFIG.SUBMENU_RULES[menuId];
    if (!rules) return item;

    const filtered = Object.entries(item.sub).reduce((acc, [route, subItem]) => {
      const rule = rules[route];

      // If no config provided, include all submenus (default behavior)
      if (!config) {
        acc[route] = subItem;
        return acc;
      }

      // Support both array and object format
      const isIncluded = Array.isArray(config)
        ? rule === true || (rule && config.includes(rule))
        : rule === true || (rule && config[rule] !== false);

      if (isIncluded) {
        acc[route] = subItem;
      }
      return acc;
    }, {});

    if (Object.keys(filtered).length === 0) {
      const { ...rest } = item;
      return rest;
    }

    return { ...item, sub: filtered };
  };

  const buildNavigation = config => {
    const result = {};

    ['general', 'products', 'financial', 'marketing', 'account'].forEach(category => {
      let firstInGroup = true;

      NAV_CONFIG.GROUPS[category].forEach(menuId => {
        if (!shouldInclude(menuId, config)) return;

        const route = menuId === '/' ? '/' : NAV_CONFIG.MENU_MAP[menuId];
        if (!route || !settings.navigation_sidebar[route]) return;

        let item = { ...settings.navigation_sidebar[route] };
        item = filterSubmenus(menuId, item, config);

        if (firstInGroup && NAV_CONFIG.LABELS[category]) {
          item.label = NAV_CONFIG.LABELS[category];
          firstInGroup = false;
        }

        result[route] = item;
      });
    });

    // Add settings
    if (settings.navigation_sidebar['/settings']) {
      const settingsItem = { ...settings.navigation_sidebar['/settings'] };
      const hasAccountItems = Object.keys(result).some(r =>
        NAV_CONFIG.GROUPS.account.map(id => NAV_CONFIG.MENU_MAP[id] || id).includes(r)
      );

      if (!hasAccountItems) {
        settingsItem.label = NAV_CONFIG.LABELS.account;
      }

      result['/settings'] = settingsItem;
    }

    return result;
  };

  return {
    get: (userData = null) => {
      try {
        const configStr = userData?.menuConfig || window.__REDUX_STORE__?.getState()?.currentUser?.menuConfig;

        if (configStr === cache.config && cache.result) {
          return cache.result;
        }

        const config = getMenuConfig(userData);
        if (!config || typeof config !== 'object') {
          // Update cache when config is null to avoid stale cache
          cache = { config: configStr, result: settings.navigation_sidebar };
          return settings.navigation_sidebar;
        }

        const result = buildNavigation(config);
        cache = { config: configStr, result };
        return result;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Navigation filter error:', error);
        return settings.navigation_sidebar;
      }
    },

    clearCache: () => {
      cache = { config: null, result: null };
    }
  };
})();

// Attach to settings
settings.getFilteredNavigationSidebar = NavigationFilter.get;
settings.clearNavigationCache = NavigationFilter.clearCache;

/* Parse GET variables to change initial settings */
const $_GET = {};
window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (a, name, value) => {
  $_GET[name] = value;
});

Object.keys($_GET).forEach(name => {
  const isTrue = $_GET[name] === '1';

  switch (name) {
    case 'setting-night-mode':
      settings.night_mode = isTrue;
      break;
    case 'setting-show-section-lines':
      settings.show_section_lines = isTrue;
      break;
    case 'setting-sidebar-small':
      settings.sidebar_small = isTrue;
      break;
    case 'setting-sidebar-dark':
      settings.sidebar_dark = isTrue;
      break;
    case 'setting-nav-dark':
      settings.nav_dark = isTrue;
      break;
    // no default
  }
});

export default settings;
